import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const inquiryApi = createApi({
  reducerPath: 'inquiryApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  endpoints: builder => ({
    addInquiry: builder.mutation<
      any,
      {
        shopId: string;
        itemId: string;
        type: string;
        options: string[];
        defectiveItems?: string;
        members?: string;
        details: string;
        numbers?: string;
        images: any[];
        video: any;
      }
    >({
      query: ({
        shopId,
        itemId,
        type,
        options,
        defectiveItems,
        members,
        details,
        numbers,
        images,
        video,
      }) => ({
        url: '/inquiry',
        method: 'POST',
        body: {
          shopId,
          itemId,
          type,
          options,
          defectiveItems,
          members,
          details,
          numbers,
          images,
          video,
        },
      }),
    }),
    addInquiryImages: builder.mutation<any, FormData>({
      query: formData => ({
        url: '/inquiry/image',
        method: 'POST',
        body: formData,
      }),
    }),
    addInquiryVideo: builder.mutation<any, FormData>({
      query: formData => ({
        url: '/inquiry/video',
        method: 'POST',
        body: formData,
      }),
    }),
    deleteInquiry: builder.mutation<any, string>({
      query: inquiryId => ({
        url: '/inquiry',
        method: 'DELETE',
        body: {
          inquiryId,
        },
      }),
    }),
    addInquiryReply: builder.mutation<any, { inquiryId: string; text: string }>(
      {
        query: ({ inquiryId, text }) => ({
          url: '/inquiry',
          method: 'PUT',
          body: {
            inquiryId,
            text,
          },
        }),
      },
    ),
  }),
});

export const {
  useAddInquiryMutation,
  useAddInquiryImagesMutation,
  useAddInquiryVideoMutation,
  useDeleteInquiryMutation,
  useAddInquiryReplyMutation,
} = inquiryApi;
